var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DialogTemplate",
    {
      staticClass: "DialogTemplateArea",
      attrs: { "is-open": _vm.isOpen },
      on: { "click-mask": _vm.onClickMask },
    },
    [
      _c(
        "div",
        { staticClass: "alertContent", class: { isPc: !_vm.isSp } },
        [
          _c("div", {
            staticClass: "text",
            class: { isPc: !_vm.isSp },
            domProps: { textContent: _vm._s(_vm.text) },
          }),
          _vm._v(" "),
          _vm.subText !== undefined
            ? _c("div", {
                staticClass: "subText",
                class: { isPc: !_vm.isSp },
                domProps: { textContent: _vm._s(_vm.subText) },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("ButtonTypeCustom", {
            staticClass: "button",
            class: { isPc: !_vm.isSp },
            attrs: {
              "button-type": "button",
              "button-text": _vm.buttonCustomText,
              "button-color": "colorPrimary",
              "button-size": "sizeLarge",
            },
            on: { "button-clicked": _vm.onClickOK },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }